import { render, staticRenderFns } from "./ChatInfo.vue?vue&type=template&id=b4067f4c&scoped=true&"
import script from "./ChatInfo.vue?vue&type=script&lang=js&"
export * from "./ChatInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfo.vue?vue&type=style&index=0&id=b4067f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4067f4c",
  null
  
)

export default component.exports